import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import FirebaseAuthService from "../../firebase/FirebaseAuthService";
import {FcGoogle} from "react-icons/fc";
import { FaPhone } from "react-icons/fa6";
import { FaFacebook,FaTwitter,} from "react-icons/fa";
import { toast } from "react-toastify";
import PhoneLogin from "./PhoneLogin";
import { useTranslation } from "react-i18next";

export default function Login() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [data, setData] = useState({
    email: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const handleChange = (e) => {
  const { name, value } = e.target;
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrorMessage("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMessage("");

    try {
        const login = await FirebaseAuthService.loginWithEmail(
            data.email,
            data.password
        );

        toast.success(t("connexion.loginSuccess") );
        navigate("/");
        window.location.reload();
    } catch (error) {
        console.error(error);
    if (error.code === "auth/email-not-verified") {

    setErrorMessage(
         t("connexion.emailNotVerified")
    )
     }  else if (error.code === "auth/user-not-found") {

            setErrorMessage( t("connexion.userNotFound") );

        } else if (error.code === "auth/wrong-password") {

            setErrorMessage(t("connexion.incorrectPassword") );

        } else if (error.code === "auth/invalid-credential") {

            setErrorMessage(t("connexion.invalidEmailOrPassword"));

        } else if (error.code === "auth/invalid-email") {

            setErrorMessage(t("connexion.invalidEmail"));

      } else {

            setErrorMessage(t("connexion.loginError"));

        }

    } finally {

        setLoading(false);

    }

};
        const handleGoogleLogin = async () => {

    try {

        setLoading(true);

        const login =
            await FirebaseAuthService.loginWithGoogle();
        toast.success(t("connexion.loginSuccess") );
        navigate("/");
        window.location.reload();

    } catch (error) {
        console.error(error);
        toast.error(
             t("connexion.loginGoogleError")
        );

    } finally {
        setLoading(false);
    }

};


const handleTwitterLogin = async () => {

    try {
        setLoading(true);
        const login =
            await FirebaseAuthService.loginWithTwitter();
        toast.success( t("connexion.loginTwitterSuccess"));

        navigate("/");

        window.location.reload();

    } catch (error) {

        console.error(error);

        toast.error(t("connexion.loginTwitterError"));

    } finally {

        setLoading(false);

    }

};



  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-5">
          <div className="card shadow">
            <div className="card-body p-4">
              <h3 className="text-center mb-4">
                 {t("connexion.login")}
              </h3>

              {errorMessage && (
                <div className="alert alert-danger">
                  {errorMessage}
                </div>
              )}

              <form onSubmit={handleSubmit}>



                <div className="mb-3">

                  <label className="form-label">
                     {t("monProfile.email")}
                  </label>

                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    value={data.email}
                    onChange={handleChange}
                    required
                  />

                </div>

                <div className="mb-3">

                  <label className="form-label">
                     {t("monProfile.password")}
                  </label>

                  <input
                    type="password"
                    name="password"
                    className="form-control"
                    value={data.password}
                    onChange={handleChange}
                    required
                  />

                </div>

                <div className="text-end mb-3">

                  <Link to="/forgot-password">
                     {t("connexion.forgotPassword")}
                  </Link>

                </div>

                <button
                  type="submit"
                  className="btn btn-success w-100"
                  disabled={loading}
                >
                  {loading
                    ?  t("connexion.loginInProgress")
                    : t("connexion.signIn")}
                </button>

                

              </form>

<hr className="my-4"/>

<div className="text-center">

    <small className="text-muted">
         {t("connexion.orContinueWith")}
    </small>

</div>


<div className="d-grid gap-2 mt-3">

    <button
        className="btn btn-outline-danger"
        onClick={handleGoogleLogin}
        disabled={loading}
        type="button"
    >

        <FcGoogle
            size={22}
            className="me-2"
        />

        {t("connexion.continueWithGoogle")}

    </button>

  

</div>


              <div className="text-center mt-3">

                <span>
                  {t("connexion.noAccount")}
                </span>

                <Link
                  to="/register"
                  className="ms-2"
                >
                   {t("connexion.createAccount")}
                </Link>

              </div>

            </div>

          </div>

        </div>

      </div>

    </div>
  );
}